import { useEffect, useRef, useState } from 'react';
import Journey from './Journey.jsx';
import Editorial from './Editorial.jsx';
const links = [['Residences','residence'],['Architecture','architecture'],['Location','location'],['Private Office','office'],['Journal','journal']];
export default function App() {
  const [menu, setMenu] = useState(false);
  const header = useRef(null);
  const menuButton = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => header.current?.classList.toggle('is-scrolled', !entry.isIntersecting), {threshold:0});
    observer.observe(document.getElementById('top-sentinel'));
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!menu) return;
    document.querySelector('#main-nav a')?.focus();
    const close = e => { if(e.key === 'Escape'){setMenu(false); menuButton.current?.focus();} };
    document.addEventListener('keydown',close);
    return () => document.removeEventListener('keydown',close);
  }, [menu]);
  return <>
    <a className="skip-link" href="#residence">Skip the cinematic tour</a>
    <div id="top-sentinel" aria-hidden="true" />
    <header ref={header} className="site-header">
      <a className="wordmark" href="#top" title="Return to the beginning"><span>AURELIA</span>{' '}<small>RESIDENCES</small></a>
      <nav className={menu ? 'main-nav is-open':'main-nav'} id="main-nav" aria-label="Main navigation">
        {links.map(([label,id]) => <a href={`#${id}`} key={id} onClick={()=>setMenu(false)}>{label}</a>)}
      </nav>
      <a className="header-inquiry" href="#office">Arrange a viewing <span aria-hidden="true">↗</span></a>
      <button className="menu-button" ref={menuButton} aria-expanded={menu} aria-controls="main-nav" onClick={()=>setMenu(!menu)}>{menu?'Close':'Menu'} <span aria-hidden="true">{menu?'−':'+'}</span></button>
    </header>
    <main id="top"><Journey /><Editorial /></main>
  </>;
}
